module.exports = __webpack_public_path__ + "static/quini-ed273f55b4ac54cb8233297758c417ff.png";